import { NextSeo } from "next-seo";
import { useUser } from "~/modules/user/hooks/useUser";
import { Navbar } from "~/components/Navbar/component";
import { Routes } from "~/routes";
import { PageTrack } from "~/modules/analytics/components/PageTrack";
import { PageWrapper, SidebarLayout } from "~/components/SidebarLayout";
import { Breadcrumbs } from "~/components/Breadcrumbs";
import { RedirectToLoginWhenNotAuthenticated } from "~/modules/auth/components/RedirectToLoginWhenNotAuthenticated";
import { McpPage } from "~/modules/mcp/pages/setup";
import { PageHeader } from "~/components/PageHeader";
import { McpNav } from "~/modules/mcp/components/McpNav";
import { FeatureNames } from "~/modules/feature_flag/flags";
import { FeatureFlag } from "~/modules/feature_flag/components/FeatureFlag";

// // // //

export default function Mcp() {
    const { user } = useUser();

    return (
        <RedirectToLoginWhenNotAuthenticated>
            <FeatureFlag
                feature={FeatureNames.enableMcpTools}
                redirect={Routes.home}
            >
                <PageTrack route={Routes.toolsMcp}>
                    <NextSeo title="MCP" />

                    <Navbar route={Routes.toolsMcp} user={user} />
                    <SidebarLayout pathname={Routes.toolsMcp}>
                        <Breadcrumbs
                            pages={[
                                {
                                    name: "Tools",
                                },
                                {
                                    name: "MCP",
                                    href: Routes.toolsMcp,
                                },
                                {
                                    name: "Settings",
                                    current: true,
                                },
                            ]}
                        />
                        <PageWrapper>
                            <PageHeader title="MCP" />
                            <McpNav page="mcp">
                                <McpPage />
                            </McpNav>
                        </PageWrapper>
                    </SidebarLayout>
                </PageTrack>
            </FeatureFlag>
        </RedirectToLoginWhenNotAuthenticated>
    );
}
